const mobilityLocaleContext=locale=>locale?{context:{headers:{'X-Mobility-Locale':locale}}}:{};export default mobilityLocaleContext;